<template>
  <div class="notifications-window">
    <notifications-window-header @close="closeNotificationsWindow" />
    <div class="notifications-window-body">
      <div class="fixed-block">
        <app-toggle-select :options="tabsOptions" v-model="activeTab" />
      </div>
      <div class="notifications-list__wrapper">
        <notifications-list
          :notifications="filteredNotifications"
          @close="closeNotificationsWindow"
        />
      </div>
    </div>
  </div>
</template>

<script>
import AppToggleSelect from '@/components/htmlHelpers/AppToggleSelect'
import NotificationsWindowHeader from '@/components/notificationsNew/NotificationsWindowHeader'
import NotificationsList from '@/components/notificationsNew/NotificationsList'
import BaseComponent from '@/components/commentsNew/BaseComponent'

export default {
  name: 'NotificationsWindow',
  extends: BaseComponent,
  components: {
    NotificationsList,
    NotificationsWindowHeader,
    AppToggleSelect
  },
  data () {
    return {
      notifications: [],
      activeTab: 'all',
      tabsOptions: [
        {
          value: 'all',
          text: 'All'
        },
        {
          value: 'comments',
          text: 'Comments'
        },
        {
          value: 'activity',
          text: 'Activity'
        },
        {
          value: 'school',
          text: 'School'
        }
      ]
    }
  },
  computed: {
    filteredNotifications: function () {
      if (this.activeTab === 'all') return this.notifications
      return this.notifications.filter(data => data.typeId === this.activeTab)
    }
  },
  mounted: function () {
    document.body.style.overflow = 'hidden'
    document.addEventListener('keyup', this.onKeyClick)
    this.fetchNotifications()
      .then(this.markNewNotificationsAsRead)
  },
  beforeDestroy () {
    document.removeEventListener('keyup', this.onKeyClick)
    document.body.style.overflow = 'auto'
  },
  methods: {
    fetchNotifications () {
      return this.$http.get('notifications')
        .then(response => {
          this.notifications = response.data.data
        })
    },
    markNewNotificationsAsRead () {
      return this.$http.put('read-new-notifications')
        .then(() => {
          this.$emit('read-new-notifications')
        })
    },
    closeNotificationsWindow () {
      this.$emit('close')
    },
    onKeyClick (event) {
      if (event.keyCode === 27) {
        this.closeNotificationsWindow()
      }
    }
  }
}
</script>

<style scoped lang="scss">
@import "src/assets/scss/variables";

.notifications-window {
  display: block;
  text-align: left;
  font-family: $font-lato;
  position: fixed;
  top: 0;
  right: 0;
  max-width: 480px;
  width: 100%;
  height: 100vh;
  background-color: $white;
  z-index: 1040;
  box-shadow: -2px 0px 2px #00000029;
  &-body {
    .fixed-block {
      padding: 16px;
      box-shadow: 0 2px 2px #00000029;
      margin-bottom: 2px;
    }
    .notifications-list__wrapper {
      .notifications-list {
        margin: 0 16px;
      }
    }
  }
}
.notifications-list__wrapper {
  position: relative;
  height: calc(100vh - 122px);
  overflow-y: scroll;
}
</style>
